<ng-container thr-parent-form>
    <div class="container">
        <div class="row">
            <!--Nuevo ADV-2351-->
            <div class="col-12 col-md-8 col-lg-6">
                <div class="product-summary">
                <ng-container *ngIf="canExonerate">
                    <div class="py-4 py-md-0">
                        <label class="mb-0">
                            {{ 'product.convenience' | translate }}
                            <span class="appropriateness ml-4" [class.not-appropriateness]="!selectedProduct.isAppropriateness">
                                <mat-icon>check</mat-icon>
                            </span>
                        </label>
                    </div>
                    <div class="d-flex">
                        <label class="mt-1 mb-0 mt-md-0">{{ 'product.exonerate' | translate }}</label>
                        <mat-radio-group class="ml-4" [disabled]="true" *ngIf="selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group class="ml-4"  name="isExonerated" [disabled]="!editable" [(ngModel)]="selectedProduct.isExonerated" (ngModelChange)="onExonerate()" *ngIf="!selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </ng-container>
                </div>
            </div>
            <!--Fin de Nuevo ADV-2351-->
            <div class="col-12">
                <mat-label class="d-block text-blue my-4">
                    {{ 'form.options-refund' | translate }}
                </mat-label>

                <mat-radio-group
                    name="action"
                    [(ngModel)]="selectedProduct.order.action"
                    (ngModelChange)="onActionChange()"
                    [required]="true"
                    [disabled]="!editable"
                >
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-11 mb-4">
                            <mat-radio-button class="d-block" name="actionTotal" color="blue-gray" [value]="OrderAction.TOTAL">
                                {{ 'form.total' | translate }}
                            </mat-radio-button>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-12 col-md-11 mb-4">
                            <mat-radio-button class="d-block" name="actionShares" color="blue-gray" [value]="OrderAction.SHARES">
                                {{ 'form.number-shares' | translate }}
                            </mat-radio-button>

                            <div class="ml-4 ml-sm-5">
                                <mat-form-field class="full-width no-padding-bottom">
                                    <input
                                        type="hidden"
                                        name="shares"
                                        [min]="0.00000001"
                                        [max]="maximumShares"
                                        [(ngModel)]="selectedProduct.order.shares"
                                        #sharesCtrl="ngModel"
                                    />
                                    <input
                                        matInput
                                        #sharesDirective="auto-numeric"
                                        thr-auto-numeric
                                        [placeholder]="'form.indicates-number-shares' | translate"
                                        required
                                        [numDecimals]="6"
                                        [currencySymbol]="''"
                                        [disabled]="selectedProduct.order.action !== OrderAction.SHARES || !editable"
                                        [value]="initialShares"
                                        (input)="onSharesChange()"
                                        *ngIf="editable || selectedProduct.order.action !== OrderAction.TOTAL"
                                    />
                                    <input
                                        matInput
                                        [placeholder]="'form.indicates-number-shares' | translate"
                                        required
                                        [disabled]="true"
                                        value="--"
                                        *ngIf="!editable && selectedProduct.order.action === OrderAction.TOTAL"
                                    />
                                </mat-form-field>
                                <div *ngIf="editable && selectedProduct.order.action === OrderAction.SHARES">
                                    <mat-error
                                        class="d-block mat-caption"
                                        *ngIf="sharesCtrl.hasError('max') && !sharesCtrl.hasError('required'); else sharesRequired"
                                    >
                                        <ng-container *ngIf="product.minimumAmountToMaintain > 0; else minimumZero">
                                            {{
                                                'form.validation.minimum-to-maintain'
                                                    | translate
                                                        : {
                                                              value: product.minimumAmountToMaintain | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                        <ng-template #minimumZero>
                                            {{ 'form.validation.cannot-transfer-more-than-you-have' | translate }}
                                        </ng-template>
                                    </mat-error>
                                    <ng-template #sharesRequired>
                                        <mat-error class="d-block mat-caption" *ngIf="!!sharesCtrl.errors">
                                            {{ 'form.validation.required' | translate }}
                                        </mat-error>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row flex-nowrap justify-content-between justify-content-md-center">
                        <div class="col-auto col-md-5 flex-shrink-1">
                            <mat-radio-button class="d-block" name="actionAmount" color="blue-gray" [value]="OrderAction.AMOUNT">
                                {{ 'form.for-amount' | translate }}:
                            </mat-radio-button>
                        </div>
                        <div class="col-auto col-md-6 text-right">
                            <mat-radio-group
                                name="typeOfWithdraw"
                                required
                                [disabled]="selectedProduct.order.action !== OrderAction.AMOUNT || !editable"
                                [(ngModel)]="selectedProduct.order.typeOfWithdraw"
                                (ngModelChange)="onResize()"
                            >
                                <mat-radio-button [value]="TypeOfWithdraw.GROSS">{{ 'form.gross' | translate }}</mat-radio-button>
                                <mat-radio-button [value]="TypeOfWithdraw.NET">{{ 'form.net' | translate }}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-11 mb-4">
                            <div class="ml-4 ml-sm-5">
                                <mat-form-field class="full-width no-padding-bottom" [class.mat-form-field-invalid]="amountCtrl.invalid">
                                    <input
                                        type="hidden"
                                        name="amount"
                                        [min]="0.01"
                                        [max]="maximumInvestment"
                                        [(ngModel)]="selectedProduct.order.amount"
                                        #amountCtrl="ngModel"
                                    />
                                    <input
                                        matInput
                                        #amountDirective="auto-numeric"
                                        thr-auto-numeric
                                        [placeholder]="'form.amount' | translate"
                                        required
                                        [disabled]="selectedProduct.order.action !== OrderAction.AMOUNT || !editable"
                                        [value]="initialAmount"
                                        (input)="onAmountChange()"
                                        *ngIf="editable || selectedProduct.order.action !== OrderAction.TOTAL"
                                    />
                                    <input
                                        matInput
                                        [placeholder]="'form.amount' | translate"
                                        required
                                        [disabled]="true"
                                        value="--"
                                        *ngIf="!editable && selectedProduct.order.action === OrderAction.TOTAL"
                                    />
                                </mat-form-field>
                                <div *ngIf="editable && selectedProduct.order.action === OrderAction.AMOUNT">
                                    <mat-hint
                                        class="d-block mat-caption"
                                        *ngIf="!amountCtrl.errors && selectedProduct.order.typeOfWithdraw === TypeOfWithdraw.NET"
                                    >
                                        {{ 'operative.net-message' | translate }}
                                    </mat-hint>
                                    <mat-hint
                                        class="d-block mat-caption"
                                        *ngIf="!amountCtrl.errors && selectedProduct.order.typeOfWithdraw === TypeOfWithdraw.GROSS"
                                    >
                                        {{ 'operative.gross-message' | translate }}
                                    </mat-hint>
                                    <mat-error
                                        class="d-block mat-caption"
                                        *ngIf="amountCtrl.hasError('max') && !amountCtrl.hasError('required'); else amountRequired"
                                    >
                                        <ng-container *ngIf="product.minimumAmountToMaintain > 0; else minimumZero">
                                            {{
                                                'form.validation.minimum-to-maintain'
                                                    | translate
                                                        : {
                                                              value: product.minimumAmountToMaintain | number: '1.0-2'
                                                          }
                                            }}
                                        </ng-container>
                                        <ng-template #minimumZero>
                                            {{ 'form.validation.cannot-transfer-more-than-you-have' | translate }}
                                        </ng-template>
                                    </mat-error>
                                    <ng-template #amountRequired>
                                        <mat-error class="d-block mat-caption" *ngIf="!!amountCtrl.errors">
                                            {{ 'form.validation.required' | translate }}
                                        </mat-error>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-radio-group>
            </div>
        </div>
        <div class="row flex-nowrap align-items-center mb-4">
            <div class="col-auto pr-0">
                <i class="icon-exclamation gray-icon-exclamation"></i>
            </div>
            <div class="col-auto flex-shrink-1 pl-2">
                <p class="mat-caption text-error font-italic mb-0">
                    {{ 'operative.refund-tax' | translate }}
                </p>
            </div>
        </div>
        <div class="row flex-nowrap align-items-center">
            <div class="col-auto pr-0">
                <i class="icon-exclamation gray-icon-exclamation"></i>
            </div>
            <div class="col-auto flex-shrink-1 pl-2">
                <p class="mat-caption text-error font-italic mb-0">
                    {{ 'operative.refund-money-iban' | translate }}:
                    <strong class="text-body">{{ contract.iban }}</strong>
                </p>
            </div>
        </div>
    </div>
</ng-container>
